import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import ViewUiPlus from 'view-ui-plus'
import './styles/color.css'
import './styles/index.less'
import {IOIClient,IOIClientOption,IOIClientConnectStatus} from 'imio-sdk-lite'

const app = createApp(App)
const pinia = createPinia()


app.use(pinia)
    .use(router)
    .use(ViewUiPlus)
    .mount('#app')

let clientOption = IOIClientOption.newBuilder().whitAppId('121').whitDebug(false).whitWss(true)
    .whitHost("ws.onlytv.lol").build();
let oyClient = IOIClient.getInstance().whitOption(clientOption);
